module.exports = __webpack_public_path__ + "media/images/icon_close-28e0926a2bf216f538ccaa97ae1b7b4c.svg";